import { render, staticRenderFns } from "./CorrectionForm.vue?vue&type=template&id=42993d30"
import script from "./CorrectionForm.vue?vue&type=script&lang=js"
export * from "./CorrectionForm.vue?vue&type=script&lang=js"
import style0 from "./CorrectionForm.vue?vue&type=style&index=0&id=42993d30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports